/** Small sprinting runner with speed trails, drawn in a white gradient. */
export const RunnerTrailIcon = ({ size = 14, className = '', id = 'runner-trail' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}
       aria-hidden="true" data-testid="runner-trail-icon">
    <defs>
      <linearGradient id={`${id}-body`} x1="12" y1="2" x2="12" y2="22" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#FFFFFF" />
        <stop offset="1" stopColor="#FFFFFF" stopOpacity="0.72" />
      </linearGradient>
      <linearGradient id={`${id}-trail`} x1="1" y1="12" x2="11" y2="12" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#FFFFFF" stopOpacity="0" />
        <stop offset="1" stopColor="#FFFFFF" stopOpacity="0.9" />
      </linearGradient>
    </defs>

    {/* speed trails */}
    <g stroke={`url(#${id}-trail)`} strokeWidth="1.8" strokeLinecap="round">
      <path d="M2.5 7.5h4.2" />
      <path d="M1.5 12h5.4" />
      <path d="M3 16.5h3.6" />
    </g>

    {/* runner */}
    <circle cx="16.2" cy="4.9" r="2.1" fill={`url(#${id}-body)`} />
    <g stroke={`url(#${id}-body)`} strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
      <path d="M15.1 8.6 11.4 12.6" />
      <path d="M11.4 12.6 13.9 17 13 20.6" />
      <path d="M11.4 12.6 8.1 15.1" />
      <path d="M15.6 9.6 19 11.6" />
      <path d="M14 8.9 10.6 9.6" />
    </g>
  </svg>
);

export default RunnerTrailIcon;
